<template>
    <div id="app">
        <router-view/>
    </div>
</template>

<script>
    import {pushVirtualPage} from './helpers/gtm';

    export default {
        name:  'App',
        watch: {
            '$route'(to) {
                const { path } = to;
                if (path) {
                    pushVirtualPage(path);
                }

            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/App.vue